import { APP_ROUTES } from '@/constants/routes';

const EMBEDDED_PLATFORM_ROOTS = [
  APP_ROUTES.WEBEX,
  APP_ROUTES.ZOOM,
  APP_ROUTES.TEAMS,
  APP_ROUTES.MEET,
];

/**
 * Where to send the user after their session is torn down. Embedded apps stay
 * on their own platform root so they re-render their NotAuthorizedView (the
 * external login flow). Navigating to `/` instead relies on
 * AppEnvironmentDetector re-detecting the platform, which misfires in e.g. the
 * Webex desktop client (not an iframe) and falls through to `/web` — whose
 * Auth0 loginWithRedirect then renders the SSO page inside the embedded app.
 */
export function getLogoutRedirectTarget(): string {
  const { pathname, search } = window.location;
  const platformRoot = EMBEDDED_PLATFORM_ROOTS.find(
    (root) => pathname === root || pathname.startsWith(`${root}/`),
  );

  return platformRoot ? `${platformRoot}${search ?? ''}` : APP_ROUTES.HOME;
}
